/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { Dispatch, SetStateAction } from "react";

import styled from "styled-components";

import { ProfileTabs } from "src/components/Profile/types";
import { ViennaPill } from "src/components/UI/ViennaPill/ViennaPill";

interface Props {
  selected: ProfileTabs;
  setSelected: Dispatch<SetStateAction<ProfileTabs>>;
}
export default function ProfilePill({ selected, setSelected }: Props) {
  const tabs: { label: string; slug: ProfileTabs }[] = [
    { label: "Plates", slug: ProfileTabs.PLATES },
    { label: "Followers", slug: ProfileTabs.FOLLOWERS },
    { label: "Following", slug: ProfileTabs.FOLLOWING },
  ];
  return (
    <PillWrapper>
      <ViennaPill tabs={tabs} selected={selected} setSelected={setSelected} />
    </PillWrapper>
  );
}

const PillWrapper = styled.div`
  margin-top: 20px;
  display: flex;
`;
